export const contactsData = {
    email: 'ydvrahul5616@gmail.com',
    phone: '+91 8890085616',
    address: 'Pune, India',
    // Google Sheet API endpoint for form submissions
    sheetAPI: 'https://api.sheetbest.com/sheets/8ee2c0f0-a193-440c-bd5d-19c3e8063da5'
};

